<template>
<div class="wire" 
@mousedown="opacity=0.5" 
@mouseup="opacity=1" 
@mouseout="opacity=1"  
:style="{opacity:opacity,height:'5px',backgroundColor:color,width:width}">
</div>
</template>

<script>
export default {
    name:"Wire",
    props:{
        color:{
            type:String,
            default:'black'
        },
        width:{
            type:String,
            default:"100%"
        }
        // height:{
        //     type:String,
        //     default:"5px"
        // }
    },
    data(){
        return{
            opacity:1
        }
    }
}
</script>

<style lang="less" scoped>
.wire{
    // width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-top: 2px;
    margin-bottom: 2px;
}
</style>